/* import nBossConnection from 'modules/base/service/nBossConnection'; */
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';
import ModelValidationTableService from '../service/ModelValidationTableService';

const config = {
	key: 'modelValidationTable',
	topic: 'modelValidation',
	service: ModelValidationTableService,
	editFormState: item => `/model-validation/edit/${item ? item.id : 'new'}`,
	toolbarAction: ['search', 'refresh', 'new'],
	rowAction: [/* 'exportData', */ 'modify', 'delete'],
	/* exportData: { tooltip: 'Export to XLSX', link: item => `${nBossConnection.basePath}modelValidationTableControl/exportToXlsx?id=${item.id}` }, */
	columns: [
		{
			key: 'name'
		}
	]
};

function ModelValidationTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('modelValidationTable', reducer('modelValidationTable'))(ModelValidationTable);
